import values from 'lodash/fp/values'
import PropTypes from 'prop-types'


const constants = {
    DEFAULT: '',
    ERROR: 'Fetch/AUTHENTICATORS_ERROR',
    PENDING: 'Fetch/AUTHENTICATORS_PENDING',
    SUCCESS: 'Fetch/AUTHENTICATORS_SUCCESS'
}

export const types = PropTypes.oneOf(values(constants))

export default constants
